import Cookies from 'js-cookie'

import Settings from 'core/settings'

export default class CookieService {
  constructor(converter = null) {
    this.service = this.initService(converter)
    this.defaults = {
      expires: 14,
      sameSite: 'Lax'
    }
  }

  setCookie(name, value, options = {}) {
    this.service.set(name, value, {
      path: '/',
      expires: options.expires || this.defaults.expires,
      secure: Settings.force_ssl,
      sameSite: options.sameSite || this.defaults.sameSite
    })
  }

  getCookie(name) {
    return this.service.get(name)
  }

  removeCookie(name) {
    this.service.remove(name)
  }

  initService(converter) {
    if (converter) {
      return Cookies.withConverter(converter)
    }

    return Cookies
  }
}
